import { XMarkIcon } from '@heroicons/react/24/outline'
import { DownloadIcon } from 'lucide-react'
import React, { useState } from 'react'

export default function LegislationFileViewer({
  selectedLegislation,
  onClose,
  iframePrintLegislation,
}) {
  const [loading, setLoading] = useState(true)

  if (!selectedLegislation) return null

  const file = selectedLegislation?.legislative_file
  if (!file?.url) return null

  const extension = file.name.split('.').pop()?.toLowerCase()

  const getIframeSrc = () => {
    if (extension === 'pdf') return file.url
    if (extension === 'doc' || extension === 'docx') {
      return `https://docs.google.com/gview?url=${encodeURIComponent(
        file.url
      )}&embedded=true&rm=minimal`
    }
    return null
  }

  const iframeSrc = getIframeSrc()
  if (!iframeSrc)
    return <p className='text-sm text-red-500'>Unsupported file format</p>

  const showPrintButton =
    iframePrintLegislation && extension !== 'pdf' && file.url

  return (
    <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4'>
      <div className='bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-hidden shadow-lg'>
        <div className='flex justify-between items-center p-6 border-b'>
          <h2 className='text-xl font-semibold text-gray-900'>
            Document Viewer
          </h2>

          <div className='flex items-center gap-3'>
            {showPrintButton && (
              <button
                onClick={() => iframePrintLegislation(selectedLegislation)}
                className='flex items-center gap-1.5 text-green-600 hover:text-green-900 text-sm font-medium transition-transform transform hover:scale-105'
                title='Print'
              >
                <DownloadIcon className='w-5 h-5' />
                Download
              </button>
            )}

            {onClose && (
              <button
                onClick={onClose}
                className='text-gray-400 hover:text-gray-600 transition-colors'
              >
                <XMarkIcon className='w-6 h-6' />
              </button>
            )}
          </div>
        </div>

        <div className='p-4 relative'>
          {loading && (
            <div className='absolute inset-0 flex items-center justify-center bg-white/70 z-10'>
              <div className='animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600'></div>
            </div>
          )}

          <iframe
            src={iframeSrc}
            className='w-full h-[80vh] border rounded-xl'
            title='Document Viewer'
            onLoad={() => setLoading(false)}
          />
        </div>
      </div>
    </div>
  )
}
